import { Video } from '@icon-park/react';
import { Fragment, memo } from 'react';

import { Button } from '@didaskill/ui/design-system';
import { useBoolState } from '@didaskill/ui/utils';

import VideoResourceItemDialog from './dialog/VideoResourceItemDialog';

export type VideoResourceItemProps = {
  videoHref: string;
};

export const VideoResourceItemBase = ({ videoHref }: VideoResourceItemProps) => {
  const [isVideoDialogOpen, onVideoDialogOpen, onVideoDialogClose] = useBoolState(false);

  return (
    <Fragment>
      <Button icon={<Video />} size={Button.SIZES.LARGE} onClick={onVideoDialogOpen} outline />

      <VideoResourceItemDialog
        isOpen={isVideoDialogOpen}
        onRequestClose={onVideoDialogClose}
        videoHref={videoHref}
      />
    </Fragment>
  );
};

VideoResourceItemBase.displayName = 'VideoResourceItem';

export default memo(VideoResourceItemBase);
